module.exports = __webpack_public_path__ + "static/media/aQI.b8e144f5.png";